import * as React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';

export default function BlogNotFound() {
  return (
    <Box
      component="main"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        minHeight: '100%',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            align="center"
            color="textPrimary"
            variant="h1"
          >
            Blog Not Found
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="subtitle2"
            sx={{ mt: 2 }}
          >
            The blog you're looking for doesn't exist or may have been removed. Try exploring other blogs.
          </Typography>
          <Box sx={{ textAlign: 'center' }}>
            <img
              alt="Not found"
              src="/static/undraw_page_not_found_su7k.svg" 
              style={{
                marginTop: 50,
                display: 'inline-block',
                maxWidth: '100%',
                width: 560
              }}
            />
          </Box>
          <Button
            startIcon={<ArrowBackIcon fontSize="small" />}
            sx={{ mt: 3 }}
            variant="contained"
            component={Link}
            to="/"
          >
            Go back
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
